import React, { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import phetsarath from "../font/PHETSARATH OT.TTF";
import moment from "moment";
import { format } from "../../App";
import { pad } from "../../data/allfunction";
let logo = "./images/full.png";
let onepay = "./images/onepay.jpg";
// Create styles
Font.register({
  family: "PHETSARATH OT",
  fonts: [{ src: phetsarath }],
});
const styles = StyleSheet.create({
  page: {
    //    backgroundColor: '#E4E4E4',
    fontFamily: "PHETSARATH OT",
    fontSize: 9,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 20,
  },
  main: {
    // paddingBottom: 50,
    flex: 1,
    //   backgroundColor: 'yellow',
    // marginBottom: 50,
  },
  header: {
    fontSize: 12,
    // marginBottom: 20,
    textAlign: "center",
    color: "red",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 0,
    left: 0,
    right: 20,
    textAlign: "right",
    // color: 'red',
  },
  row: {
    width: "100%",
    flexDirection: "row",
  },
  box: {
    //   backgroundColor: 'pink',
    flex: 1,
    margin: 5,
  },
  logo1: {
    width: 90,
    // height:100
  },
  itemCenter: {
    alignItems: "center",
  },
  tr: {
    borderWidth: 0.5,
    width: "100%",
    flexDirection: "row",
  },
  th1: {
    //   backgroundColor: 'pink',
    flex: 2,
    margin: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  th5: {
    //    backgroundColor: 'pink',
    flex: 5,
    margin: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  th8: {
    //    backgroundColor: 'pink',
    flex: 10,
    margin: 1,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  td1: {
    // backgroundColor: 'pink',
    flex: 2,
    margin: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingRight: 3,
  },
  td5: {
    // backgroundColor: 'pink',
    flex: 5,
    margin: 1,
    alignItems: "flex-end",
    justifyContent: "center",
    paddingRight: 5,
  },
  td8: {
    // backgroundColor: 'pink',
    flex: 8,
    margin: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingRight: 5,
  },
  boxTotal: {
    flex: 1,
    flexDirection: "row",
    margin: 5,
    // backgroundColor: 'pink',
    justifyContent: "center",
    alignItems: "center",
  },
  f8: {
    fontSize: 8,
  },
  f12: {
    fontSize: 12,
    fontWeight: "bold",
  },
});

// Create Document Component111
const PDFReport_2 = (props) => {
  const [user, setuser] = useState("");
  const [datas, setdatas] = useState([]);
  const [premuim_ConfirmS, setpremuim_ConfirmS] = useState(0);
  const [total_premuim_ConfirmS, settotal_premuim_ConfirmS] = useState(0);
  const [commission_ConfirmS, setcommission_ConfirmS] = useState(0);
  const [ZJIIncom_ConfirmS, setZJIIncom_ConfirmS] = useState(0);
  const [total_zji_get_ConfirmS, settotal_zji_get_ConfirmS] = useState(0);
  const [ZJItax_ConfirmS, setZJItax_ConfirmS] = useState(0);
  const [totaldipos_ConfirmS, settotaldipos_ConfirmS] = useState(0);
  const [countCancle_ConfirmS, setcountCancle_ConfirmS] = useState(0);
  const [policy_no_start, setpolicy_no_start] = useState(0);
  const [policy_no_end, setpolicy_no_end] = useState(0);
  const [sent_user_name, setsent_user_name] = useState("");
  const [where, setwhere] = useState("");
  useEffect(() => {
    setuser(props.user);
    setdatas(props.datas);
    setpremuim_ConfirmS(props.premuim_ConfirmS);
    settotal_premuim_ConfirmS(props.total_premuim_ConfirmS);
    setcommission_ConfirmS(props.commission_ConfirmS);
    setZJIIncom_ConfirmS(props.ZJIIncom_ConfirmS);
    settotal_zji_get_ConfirmS(props.total_zji_get_ConfirmS);
    setZJItax_ConfirmS(props.ZJItax_ConfirmS);
    settotaldipos_ConfirmS(props.totaldipos_ConfirmS);
    setcountCancle_ConfirmS(props.countCancle_ConfirmS);
    setpolicy_no_start(props.policy_no_start);
    setpolicy_no_end(props.policy_no_end);
    setsent_user_name(props.sent_user_name);
    setwhere(props.where);
  }, [
    props.datas,
    props.ZJIIncom_ConfirmS,
    props.ZJItax_ConfirmS,
    props.commission_ConfirmS,
    props.countCancle_ConfirmS,
    props.policy_no_end,
    props.policy_no_start,
    props.premuim_ConfirmS,
    props.sent_user_name,
    props.total_premuim_ConfirmS,
    props.user,
    props.where,
    props.totaldipos_ConfirmS,
    props.total_zji_get_ConfirmS,
  ]);

  return (
    <Document>
      <Page
        orientation="landscape"
        size="A4"
        style={styles.page}
        // wrap={true}
        wrap
      >
        <View style={styles.main}>
          {/* <Text style={styles.header} fixed>
          ~ Created with react-pdf ~
        </Text> */}
          {/* -------------ຫົວແຖວໂລໂກ້----------- */}
          <View style={styles.row}>
            <View style={{ ...styles.box, ...styles.itemCenter }}>
              <Image src={logo} style={styles.logo1} />
            </View>
            <View
              style={{
                ...styles.box,
                ...styles.itemCenter,
                ...{ justifyContent: "flex-end" },
              }}
            >
              <Text style={styles.f12}>ສະຫຼຸບການຂາຍ/ Sale Report </Text>
            </View>
            <View style={{ ...styles.box, ...styles.itemCenter }}>
              <Text style={styles.f8}>ສຳນັກງານໃຫຍ່</Text>
              <Text style={styles.f8}>
                ຖະໜົນ 450 ປີ ບ້ານ ສະພັງເມີກ, ເມືອງໄຊທານີ, ນະຄອນຫຼວງວຽງຈັນ
              </Text>
              <Text style={styles.f8}>ສປປ ລາວ. ໂທຣ: +856 21 713 116</Text>
              <Text style={styles.f8}>
                www.zhongjiinsurance.com, Facebook:Zongjiinsurance
              </Text>
              <Text style={styles.f8}>
                ເບີສຸກເສີນ 24 ຊົ່ວໂມງ +856-20 5799 9922-33
              </Text>
            </View>
          </View>
          {/* -------------ສຸດຫົວແຖວໂລໂກ້----------- */}

          {/* -------------ຊື່ຕົວແທນ----------- */}
          <View style={styles.row}>
            <View style={{ ...styles.box }}>
              <Text>ຊື່ຕົວແທນ: {sent_user_name}</Text>
            </View>
            <View style={{ ...styles.box }}>
              {where === "s" && (
                <Text>
                  ຈາກເລກທີສັນຍາ {policy_no_start} ຫາ {policy_no_end}
                </Text>
              )}
              {where === "dete" && (
                <Text>
                  ຈາກວັນທີີ {policy_no_start} ຫາ {policy_no_end}
                </Text>
              )}
              {where === "ajent" && <Text>ຈາກຕົວແທນທີ່ຍັງບໍ່ທັນໄດ້ຈ່າຍ</Text>}
            </View>
          </View>
          {/* -------------ສຸດຊື່ຕົວແທນ----------- */}

          {/* -------------ຫົວແຖວຕາຕະລາງ----------- */}
          <View fixed style={styles.tr}>
            <View style={{ ...styles.th1 }}>
              <Text>ລຳດັບ</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ຕົວແທນຂາຍ</Text>
            </View>

            <View style={{ ...styles.th5 }}>
              <Text>ເລກທີສັນຍາ</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ເລກທະບຽນ</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ວັນທີສິ້ນສຸດ</Text>
              <Text>ການຄຸ້ມກັນ</Text>
            </View>
            <View style={{ ...styles.th8 }}>
              <Text>ຊື່ລູກຄ້າ</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ລາຍຮັບທັງໝົ້ດ</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ກ່ອນອາກອນ</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ເປີເຊັນຕົວແທນ</Text>
              <Text> ( ຄ່າຄອມ</Text>
              <Text>- ຈ່າຍຊ້າ) </Text>
            </View>
            {/* <View style={{ ...styles.th5 }}>
              <Text>ເງິນຝາກຄັງ</Text>
            </View> */}
            <View style={{ ...styles.th5 }}>
              <Text>ລາຍຮັບຕົວ</Text>
              <Text>ແທນຫັກອາ</Text>
              <Text>ກອນແລ້ວ</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ລາຍຮັບເຂົ້າ ZJI</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ມອບເຂົ້າ ZJI ສຸດທິ</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ສະຖານະ</Text>
            </View>
            <View style={{ ...styles.th5 }}>
              <Text>ຈຳນວນມື້</Text>
            </View>
          </View>
          {/* -------------ສຸດຫົວແຖວຕາຕະລາງ----------- */}
          {/* -------------ເນື້ອໃນຕາຕະລາງ----------- */}
          {datas.map((e, i) => {
            return (
              <View key={i} style={styles.tr}>
                <View style={{ ...styles.td1 }}>
                  <Text>{i + 1}</Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text>
                    {e.userText}
                    {e.USER}
                  </Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text>
                    {e.policy_type}-{pad(e.no)}
                  </Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text>{e.o_plate}</Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text> {moment(e.end).format("DD/MM/YYYY")}</Text>
                </View>
                <View style={{ ...styles.td8 }}>{string(e.o_name)}</View>
                <View style={{ ...styles.td5 }}>
                  <Text> {format(e.total_premuim)}</Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text> {format(e.premuim)}</Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text>
                    {e.paid === 1
                      ? e.commission_percen
                      : format(e.commission_percen_first) + "-" + e.paylate}
                    % ={format(e.commission_percen)}
                  </Text>
                </View>
                {/* <View style={{ ...styles.td5 }}>
                  <Text>
                    {" "}
                    {e.Diposit}% = {format(e.depos)}{" "}
                  </Text>
                </View> */}
                <View style={{ ...styles.td5 }}>
                  <Text> {format(e.Text116)}% ={format(e.commission)}</Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text> {format(e.zji_get)}</Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text> {format(e.zji_total_get)}</Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text> {e.paid === 1 ? "ຊຳລະແລ້ວ" : "ຄ້າງຊຳລະ"}</Text>
                </View>
                <View style={{ ...styles.td5 }}>
                  <Text> {e.day_diff}</Text>
                </View>
              </View>
            );
          })}
          {/* -------------ສຸດເນື້ອໃນຕາຕະລາງ----------- */}

          {/* -------------ລວມທັງໝົ້ດ----------- */}
          {
            <View style={styles.tr}>
              <View style={{ ...styles.td1 }}>
                <Text>{}</Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text></Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text></Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text></Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text></Text>
              </View>
              <View style={{ ...styles.td8 }}>
                <Text>Total=</Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text> {format(total_premuim_ConfirmS)}</Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text> {format(premuim_ConfirmS)}</Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text> </Text>
              </View>
              {/* <View style={{ ...styles.td5 }}>
                <Text> {format(totaldipos_ConfirmS)} </Text>
              </View> */}
              <View style={{ ...styles.td5 }}>
                <Text> {format(commission_ConfirmS)}</Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text> {format(ZJIIncom_ConfirmS)}</Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text> {format(total_zji_get_ConfirmS)}</Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text></Text>
              </View>
              <View style={{ ...styles.td5 }}>
                <Text></Text>
              </View>
            </View>
          }
          {/* -------------ສຸດລວມທັງໝົ້ດ----------- */}

          {/* -------------ສະຫຼຸບລາຍການ----------- */}
          <View style={{ ...styles.row, ...{ marginTop: 5 } }}>
            <View style={{ flex: 1, alignItems: "center" }}>
              <Text>
              ຈຳນວນເງິນລາຍຮັບຕາມສັນຍ:: {format(total_premuim_ConfirmS)}
              </Text>
              <Text>
              ຈຳນວນເງິນລາຍຮັບກ່ອນອາກອນ: {format(premuim_ConfirmS)}
              </Text>
              <Text>ຈຳນວນເງິນທີຕົວແທນໄດ້ຮັບ ພາຍຫຼັງຫັກອາກອນ:: {format(commission_ConfirmS)}</Text>
              <Text>ຈຳນວນເງິນທີ່ ZJI ໄດ້ຮັບ:: {format(ZJIIncom_ConfirmS)}</Text>
              <Text>
                ຈຳນວນເງິນທີ ZJI ໄດ້ຮັບສຸດທິ :: {format(total_zji_get_ConfirmS)}
              </Text>
            </View>

            <View style={{ flex: 1, alignItems: "center" }}>
              <Text>ຈຳນວນສັນຍາທັງໝົດ {datas.length}</Text>
              <Text>ຈຳນວນສັນຍາຖືກຍົກເລີກ:: {countCancle_ConfirmS}</Text>
            </View>
            <View style={{ flex: 1, alignItems: "center" }}>
              <Image
                src={onepay}
                style={{
                  width: 60,
                  height: 60,
                }}
              />
            </View>
            <View style={{ flex: 1, alignItems: "center" }}>
              <Text> 45 ວັນຂື້ນໄປ ຖືກລົບ 1%</Text>
              <Text>60 ວັນຂື້ນໄປ ຖືກລົບ 2%</Text>
              <Text>90 ວັນຂື້ນໄປ ຖືກລົບ 5%</Text>
              <Text>120 ວັນຂື້ນໄປ ຖືກຍົກເລີກ ຄ່ານາຍໜ້າ</Text>
            </View>
          </View>
          {/* -------------ສຸດສະຫຼຸບລາຍການ----------- */}
          {/* -------------ລາຍເຊັນ----------- */}
          <View style={{ ...styles.row, ...{ marginTop: 5 } }}>
            <View style={{ flex: 1, alignItems: "center" }}>
              <Text>_ _ _ / _ _ _ {moment(Date.now()).format(" / YYYY")}</Text>
              <Text>ຕົວແທນຂາຍ</Text>
            </View>
            <View style={{ flex: 1, alignItems: "center" }}>
              <Text>_ _ _ / _ _ _ {moment(Date.now()).format(" / YYYY")}</Text>
              <Text>ພະແນກບັນຊີ</Text>
            </View>
            <View style={{ flex: 1, alignItems: "center" }}>
              <Text>{moment(Date.now()).format("DD / MM / YYYYY")}</Text>
              <Text>ພະນັກງານຄຸ້ມຄອງ</Text>
            </View>
          </View>
          {/* -------------ສຸດລາຍເຊັນ----------- */}
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `ສ້າງໂດຍ ${user}  Page ${pageNumber} of ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default PDFReport_2;

function string(txt) {
  try {
    let long_txt = 18;
    let count_txt = txt.length;
    let data = [];
    for (let a = 0; a <= count_txt; a += long_txt) {
      data.push(<Text>{txt.substring(a === 0 ? 0 : a, a + long_txt)}</Text>);
    }
    return data;
  } catch (error) {
    return "...";
  }
}
